import { render, staticRenderFns } from "./GridTab.vue?vue&type=template&id=68b1ead8&scoped=true&"
import script from "./GridTab.vue?vue&type=script&lang=js&"
export * from "./GridTab.vue?vue&type=script&lang=js&"
import style0 from "./GridTab.vue?vue&type=style&index=0&id=68b1ead8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1ead8",
  null
  
)

export default component.exports